// extracted by mini-css-extract-plugin
module.exports = {"resume":"resume-module--resume--1nHIi","skills":"resume-module--skills--3IsdO","resumePosition":"resume-module--resumePosition--vDn_W"};